if (!customElements.get('sc-sticky-atc')) {
  customElements.define(
    'sc-sticky-atc',
    class ScStickyAtc extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(this.querySelector('[data-sc-sticky-variants]').textContent);
        } catch {
          this.variants = [];
        }
        this.select = this.querySelector('select[name="id"]');
        this.idInput = this.querySelector('[name="id"]');
        this.price = this.querySelector('[data-sc-sticky-price]');
        this.image = this.querySelector('[data-sc-sticky-image]');
        this.button = this.querySelector('.sc-sticky-atc__add');

        this.select?.addEventListener('change', () => this.show(this.select.value));
        this.show(this.idInput.value);

        // Follow the variant chosen in the main product form.
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
            if (!variant) return;
            if (this.select) this.select.value = variant.id;
            this.show(variant.id);
          });
        }

        this.past = false;
        this.atFooter = false;
        const trigger =
          document.querySelector('product-info [id^="ProductSubmitButton-"]') || document.querySelector('product-info');
        const footer = document.querySelector('.shopify-section-group-footer-group, footer');

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === trigger) {
              this.past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            } else {
              this.atFooter = entry.isIntersecting;
            }
          });
          this.toggle(this.past && !this.atFooter);
        });
        if (trigger) this.observer.observe(trigger);
        if (footer) this.observer.observe(footer);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }

      toggle(visible) {
        // Keep it on screen while the theme editor has it selected.
        if (window.Shopify?.designMode && this.closest('.shopify-section')?.classList.contains('is-selected')) visible = true;
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
      }

      show(id) {
        const variant = this.variants.find((v) => String(v.id) === String(id));
        if (!variant) return;
        this.price.innerHTML = '';
        if (variant.compare) {
          const s = document.createElement('s');
          s.textContent = variant.compare;
          this.price.append(s, ' ');
        }
        this.price.append(variant.price);
        if (this.image && variant.image) this.image.src = variant.image;
        this.button.querySelector('span').textContent = variant.label;
        this.button.disabled = !variant.available;
      }
    }
  );
}

document.addEventListener('shopify:section:select', (event) => {
  const bar = event.target.querySelector('sc-sticky-atc');
  if (!bar) return;
  event.target.classList.add('is-selected');
  bar.toggle(true);
});
document.addEventListener('shopify:section:deselect', (event) => {
  const bar = event.target.querySelector('sc-sticky-atc');
  if (!bar) return;
  event.target.classList.remove('is-selected');
  bar.toggle(bar.past && !bar.atFooter);
});
